import { render, staticRenderFns } from "./contrast.vue?vue&type=template&id=b0d5ea30&scoped=true&"
import script from "./contrast.vue?vue&type=script&lang=js&"
export * from "./contrast.vue?vue&type=script&lang=js&"
import style0 from "./contrast.vue?vue&type=style&index=0&id=b0d5ea30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d5ea30",
  null
  
)

export default component.exports